import { useMemo } from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import { TemplateStudioModel } from 'common/contracts';
import { templateStudioStateService } from 'state/template-studio.state.service';
import { z } from 'zod';

import { BlockMetadata } from 'components/TemplatesStudio/DesignsMetadata/types';

import { templateStudioSchema } from '../../../validation-schema';
import { DesignSidebarItem } from '../Components/DesignSidebarItem';

const DAILY_BONUS_BADGE_OBJECT_PATH = 'dailyBonusBadge';

const getDailyBonusBadgesDesignsByFilter = ({
  themes
}: {
  themes: TemplateStudioModel['dailyBonusBadge']['themes'];
}): BlockMetadata[] => {
  const relevantDesigns =
    templateStudioStateService.relevantDailyBonusBadgesDesigns.get() || [];

  return relevantDesigns.filter((currentDesign) => {
    return (
      !themes || themes.length === 0 || themes.includes(currentDesign.theme)
    );
  });
};

export const DailyBonusBadgesSecondarySidebar: React.FC = () => {
  const { control } = useFormContext<z.infer<typeof templateStudioSchema>>();

  const dailyBonusBadgeObject: TemplateStudioModel[typeof DAILY_BONUS_BADGE_OBJECT_PATH] =
    useWatch({
      control,
      name: DAILY_BONUS_BADGE_OBJECT_PATH
    });

  const { themes } = dailyBonusBadgeObject;

  const designs = useMemo(() => {
    return getDailyBonusBadgesDesignsByFilter({ themes });
  }, [themes]);

  return (
    <>
      {designs.map((design) => (
        <DesignSidebarItem
          key={design.id}
          {...design}
          blockDesignIdPath="dailyBonusBadge.selectedDesignId"
        />
      ))}
    </>
  );
};
